import React, { useState } from "react";
import { Card, Form, Button, Alert, Spinner } from "react-bootstrap";
import { callApi } from "@/utils/callApi";
import { useMsal } from "@azure/msal-react";

export default function IansUploadPage() {
    const [fileName, setFileName] = useState("");
    const [selectedFile, setSelectedFile] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [message, setMessage] = useState(null);
    const [messageType, setMessageType] = useState("success");

    const { instance, accounts } = useMsal();

    const handleFileSelect = (e) => {
        setSelectedFile(e.target.files[0]);
        setMessage(null);
    };

    const handleUpload = async () => {
        // Validation
        if (!fileName.trim()) {
            setMessage("Please enter a file name");
            setMessageType("danger");
            return;
        }

        if (!selectedFile) {
            setMessage("Please select a file to upload");
            setMessageType("danger");
            return;
        }

        setUploading(true);
        setMessage(null);

        try {
            // Construct the endpoint
            const endpoint = `/api/files/${fileName.trim()}`;
            
            console.log(`[UPLOAD] Uploading to: ${endpoint}`);
            console.log(`[UPLOAD] File:`, selectedFile.name, selectedFile.size, 'bytes');

            // Create FormData
            const formData = new FormData();
            formData.append('file', selectedFile);

            // Upload using callApi with FormData
            await callApi(
                endpoint,
                {
                    method: 'PUT',
                    body: formData,
                    headers: {} // Don't set Content-Type - browser will set it with boundary
                },
                instance,
                accounts
            );

            console.log('[UPLOAD] Success!');
            setMessage(`File uploaded successfully to ${endpoint}`);
            setMessageType("success");
            
            // Clear form
            setFileName("");
            setSelectedFile(null);
            // Reset file input
            document.getElementById('fileInput').value = '';

        } catch (error) {
            console.error('[UPLOAD] Error:', error);
            setMessage(`Upload failed: ${error.message}`);
            setMessageType("danger");
        } finally {
            setUploading(false);
        }
    };

    return (
        <div style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto' }}>
            <h2 className="mb-4">Ian's File Upload Page</h2>
            
            <Card className="shadow-sm">
                <Card.Body>
                    <Card.Title>Upload File to Custom Endpoint</Card.Title>
                    <Card.Text className="text-muted mb-4">
                        Enter a file identifier and select a file to upload. The file will be uploaded to <code>/api/files/{'<your-identifier>'}</code>
                    </Card.Text>
                     
                     <Form.Group className="mb-4">
                        <Form.Label>Select File</Form.Label>
                        <Form.Control
                            id="fileInput"
                            type="file"
                            onChange={handleFileSelect}
                            disabled={uploading}
                        />
                        
                        {selectedFile && (
                            <Form.Text className="text-muted">
                                Selected: <span style={{ fontFamily: "'Neutraface-Demi', Arial, sans-serif" }}>{selectedFile.name}</span> ({(selectedFile.size / 1024).toFixed(2)} KB)
                            </Form.Text>
                        )}
                    </Form.Group>

                    {/* File Name Input */}
                    <Form.Group className="mb-3">
                        <Form.Label>File Identifier (endpoint name)</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="e.g., MyDocument, Report2024, etc."
                            value={fileName}
                            onChange={(e) => setFileName(e.target.value)}
                            disabled={uploading}
                        />
                        <Form.Text className="text-muted">
                            This will be used as: /api/files/<span style={{ fontFamily: "'Neutraface-Demi', Arial, sans-serif" }}>{fileName || 'identifier'}</span>
                        </Form.Text>
                    </Form.Group>

                    {/* File Picker */}
                   
                    {/* Upload Button */}
                    <Button
                        variant="primary"
                        onClick={handleUpload}
                        disabled={uploading || !fileName.trim() || !selectedFile}
                        className="w-100"
                    >
                        {uploading ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Uploading...
                            </>
                        ) : (
                            'Upload File'
                        )}
                    </Button>

                    {/* Success/Error Message */}
                    {message && (
                        <Alert variant={messageType} className="mt-3 mb-0">
                            {message}
                        </Alert>
                    )}
                </Card.Body>
            </Card>
        </div>
    );
}
